// src/Faqs.js

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FAQAccordion from "../components/ui/FAQAccordion";
import { IMAGES } from "../assets/img/ImageIndex";

function Faqs() {
  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Business Loan FAQs | How to Qualify & Apply | EnvoCapital';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Find answers to common questions about qualifying for a business loan, required documents, interest rates, and how the funding process works at EnvoCapital.');
    }
  }, []);

  return (
    <div className="loan-program-page">
        <div className="page-banner-area bg-gray2">
            <div className="container mw-1380">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="page-banner-content">
                            <ul className="ps-0 list-unstyled breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li>FAQs</li>
                            </ul>
                            <h1>Everything You Need to Know About Business Loans</h1>
                            <p>We understand that securing the right financing is a major decision for any business. This FAQ section is designed to give you clear, straightforward answers about our loan process, eligibility, documentation, timelines, and terms. Our aim is to help you make confident, informed choices as you move your business toward growth and success.</p>
                            {/* <Link to="/calculate-mortgage/" className="read-more text-primary">
                                Calculate Your Payments
                                <i className="fi fi-rs-arrow-right"></i>
                            </Link> */}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="page-banner-img text-center text-lg-end position-relative z-1">
                            <img src={IMAGES.bannerImg8} className="img" alt="banner-img"/>
                            <img src={IMAGES.shape7} className="shape shape-7" alt="Shape1"/>
                            <img src={IMAGES.shape8} className="shape shape-8" alt="Shape2"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
        <div className="faq-area ptb-130">
            <div className="container mw-1380">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="faq-img">
                            <img decoding="async" src={IMAGES.faq} alt="faq"/>
                            <Link to="/contact-us" className="read-more">
                                Contact With Us
                                <i className="fi fi-rs-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="faq-content">
                            <h2>Find Answers to Your Business Funding Questions</h2>
                        </div>
                        <div className="accordion faq" id="accordionExample2">
                            <FAQAccordion 
                                items={[
                                        {
                                            title: 'Who is EnvoCapital?',
                                            content: (
                                                <p>EnvoCapital is a leading provider of specialized financial solutions designed to help small and medium-sized businesses reach their full potential.
                                                </p>
                                            )
                                        },
                                        {
                                            title: 'How Can EnvoCapital Help My Business?',
                                            content: (
                                                <p>EnvoCapital provides customized financing options, including flexible loans and lines of credit tailored to your needs. With expert guidance and continuous support, we help your business thrive and succeed.
                                                </p>
                                            )
                                        },
                                        {
                                            title: 'What Financial Solutions Does EnvoCapital Offer?',
                                            content: (
                                                <p>EnvoCapital offers flexible term loans, lines of credit, and creative, customized financing solutions tailored to your business needs.
                                                </p>
                                            )
                                        },
                                        {
                                            title: 'What can I use the funding towards?',
                                            content: (
                                                <p>EnvoCapital allows flexibility in the use of funds, provided they are for legitimate business purposes.
                                                </p>
                                            )
                                        },
                                        {
                                            title: 'Do I need to provide securities to qualify?',
                                            content: (
                                                <p>No, EnvoCapital offers unsecured loans. In certain cases, EnvoCapital may secure our financing with a general lien on your business assets and/ or a personal guarantee. However, rest assured, your personal assets are not used as collateral. We priorities businesses which have business revenue more than $300K.
                                                </p>
                                            )
                                        },
                                        {
                                            title: 'Can I qualify for a business loan or line of credit if I have bad credit?',
                                            content: (
                                                <p>Absolutely! Each applicant is considered on a case-by-case basis. Even with bad credit, you can still qualify for a business loan or line of credit. We consider your overall business health, not just your credit score.
                                                </p>
                                            )
                                        }
                                ]} 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Faqs;
